module.exports = __webpack_public_path__ + "static/media/icon-lock-step.02135181.svg";